import { AfterViewInit, Component, ElementRef, Inject, Injector, Input, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClientCaseStudy } from '../../client-case-studies';
import { runAfterHydration } from '../../../shared/run-after-hydration';
import { initPageScrollReveal } from '../../../shared/scroll-reveal.util';

@Component({
  selector: 'app-client-case-study',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './client-case-study.component.html',
  styleUrl: './client-case-study.component.scss',
})
export class ClientCaseStudyComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) caseStudy!: ClientCaseStudy;
  @ViewChild('caseRoot') caseRoot!: ElementRef<HTMLElement>;

  private cleanups: Array<() => void> = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private injector: Injector
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      runAfterHydration(this.injector, () => void this.setupScrollRevealAnimation());
    }
  }

  ngOnDestroy(): void {
    this.cleanups.forEach((cleanup) => cleanup());
    this.cleanups = [];
  }

  private async setupScrollRevealAnimation(): Promise<void> {
    const root = this.caseRoot?.nativeElement;
    if (!root) return;
    await initPageScrollReveal(root, this.cleanups);
  }
}
